import { render, staticRenderFns } from "./SubastaModalReAsig.vue?vue&type=template&id=63d110dc"
import script from "./SubastaModalReAsig.vue?vue&type=script&lang=js"
export * from "./SubastaModalReAsig.vue?vue&type=script&lang=js"
import style0 from "./SubastaModalReAsig.vue?vue&type=style&index=0&id=63d110dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports